import { combineReducers } from 'redux';
import { call, put, takeEvery } from 'redux-saga/effects';
import filesApi from '../api';
import {
  createApiActionCreators,
  createActionCreator,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
} from '../../../common/utils/reduxHelpers';

/**
 * ACTION TYPES
 */
export const UPLOAD_FILE = 'files/UPLOAD_FILE';
export const REMOVE_UPLOADED_FILE = 'files/REMOVE_UPLOADED_FILE';
export const RESET_UPLOADED_FILES = 'files/RESET_UPLOADED_FILES';

/**
 * ACTIONS
 */
export const uploadFileActions = createApiActionCreators(UPLOAD_FILE);
export const removeUploadedFileAction = createActionCreator(REMOVE_UPLOADED_FILE);
export const resetUploadedFilesAction = createActionCreator(RESET_UPLOADED_FILES);

/**
 * REDUCERS
 */
const initialState = {
  uploadedFiles: {},
};

const uploadedFiles = createReducer(initialState.uploadedFiles, {
  [UPLOAD_FILE]: {
    [SUCCESS]: (state, { uploadedFilesId, data }) => ({
      ...state,
      [uploadedFilesId]: [...state[uploadedFilesId], data],
    }),
  },
  [REMOVE_UPLOADED_FILE]: (state, { uploadedFilesId, fileId }) => ({
    ...state,
    [uploadedFilesId]: state[uploadedFilesId].filter(file => file.id !== fileId),
  }),
  [RESET_UPLOADED_FILES]: (state, payload) => ({
    ...state,
    [payload]: [],
  }),
});

export default combineReducers({
  uploadedFiles,
});

/**
 * SELECTORS
 */
export const selectFilesState = state => state.files;
export const selectUploadedFiles = state => selectFilesState(state).uploadedFiles;
export const selectUploadedFilesById = (state, uploadedFilesId) =>
  selectUploadedFiles(state)[uploadedFilesId] || [];
export const selectUploadedFilesListById = (state, uploadedFilesId) =>
  selectUploadedFilesById(state, uploadedFilesId).map(file => ({
    name: file.name,
    status: 'done',
    uid: file.id,
  }));

/**
 * SAGAS
 */
export function* uploadFile({ payload }) {
  const { uploadedFilesId, formData, single } = payload;
  const resp = yield call(filesApi.uploadFile, formData);

  if (resp.ok) {
    if (single === true) {
      yield put(resetUploadedFilesAction(uploadedFilesId));
    }
    yield put(
      uploadFileActions.success({
        data: resp.data,
        uploadedFilesId: uploadedFilesId,
      })
    );
  }

  return resp;
}

export function* filesSaga() {
  yield takeEvery(createActionType(UPLOAD_FILE, REQUEST), uploadFile);
}



// WEBPACK FOOTER //
// ./src/features/files/ducks/index.js